import { Injectable, computed } from "@angular/core";
import type { IFirmUser, IiFirmUsersMap } from "@interfaces/index";
import { IFirmService } from "@classes";

@Injectable({ providedIn: "root" })
export class IFirmUsersService extends IFirmService<IFirmUser> {
    protected getMessage = "getiFirmUsers";
    protected gotMessage = "gotiFirmUsers";

    public users = this.items;

    readonly usersById = computed<IiFirmUsersMap>(() => {
        const items = this.users();
        if (!items || !items.length) return;

        const map: IiFirmUsersMap = new Map();
        for (const user of items) map.set(user.UserId.toString(), user);
        return map;
    });

    protected async load(): Promise<IFirmUser[]> {
        const result = await super.load();
        if (!result) return [];
        return result.users.Data;
    }

    public async getUsers() {
        return this.getItems();
    }
}
